// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-containter[data-v-b8f49712]{width:288px;height:auto}", ""]);
// Exports
module.exports = exports;
